// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1GQ8Q","title":"Images90_title__2Dwuh","images":"Images90_images__rHuCa"};